import VendorInformation from '../pages/VendorInformation';
import { ROUTES } from './routes.config';

export const VendorInformationRoutes = {
  path: ROUTES.VENDOR_INFORMATION,
  element: <VendorInformation />,
};
  
